import { useState } from 'react';
import {
  Badge, Box, Button, IconButton, List, ListItem, ListItemText, Popover, Stack, Typography,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function Avisos() {
  const qc = useQueryClient();
  const [ancla, setAncla] = useState<HTMLElement | null>(null);

  const { data } = useQuery({
    queryKey: ['avisos'],
    queryFn: () => api.avisos(),
    refetchInterval: 60_000,
  });

  const marcarTodo = useMutation({
    mutationFn: api.marcarTodoLeido,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['avisos'] }),
  });

  const sinLeer = data?.unread ?? 0;

  return (
    <>
      <IconButton size="small" color="inherit" onClick={(e) => setAncla(e.currentTarget)}>
        <Badge badgeContent={sinLeer} color="primary">
          <NotificationsIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={ancla !== null}
        anchorEl={ancla}
        onClose={() => setAncla(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ width: 380, maxHeight: 460, overflow: 'auto' }}>
          <Stack
            direction="row"
            sx={{ alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 1.5 }}
          >
            <Typography variant="subtitle2">Avisos</Typography>
            {sinLeer > 0 && (
              <Button size="small" onClick={() => marcarTodo.mutate()}>
                Marcar todo como leído
              </Button>
            )}
          </Stack>

          {!data?.items.length ? (
            <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
              No hay avisos.
            </Typography>
          ) : (
            <List dense>
              {data.items.slice(0, 25).map((a) => (
                <ListItem
                  key={a.id}
                  sx={{ bgcolor: a.readAt ? undefined : 'action.hover', alignItems: 'flex-start' }}
                >
                  <ListItemText
                    primary={a.title}
                    secondary={
                      <>
                        {/* Los motivos de descarte vienen en varias líneas. */}
                        {a.body && (
                          <Typography variant="caption" sx={{ whiteSpace: 'pre-line', display: 'block' }}>
                            {a.body}
                          </Typography>
                        )}
                        <Typography variant="caption" color="text.secondary">
                          {new Date(a.createdAt).toLocaleString('es-ES')}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Popover>
    </>
  );
}
